import fallbackLogo from '@/images/coloredfinallogochanged.png'

/**
 * Proxies remote article images through wsrv.nl for resize + WebP on the fly.
 * Local assets and data URLs pass through unchanged.
 */

export const FALLBACK_ARTICLE_IMAGE =
  fallbackLogo

const WSRV_BASE = 'https://wsrv.nl/'

export function optimizeImage(url, width = 280, height = 158) {
  if (url == null || url === '') return FALLBACK_ARTICLE_IMAGE

  const s = String(url).trim()
  if (s === '') return FALLBACK_ARTICLE_IMAGE

  if (s.startsWith('/') || s.startsWith('blob:') || s.startsWith('data:')) return s
  if (s.includes('wsrv.nl')) return s

  return `${WSRV_BASE}?${new URLSearchParams({
    url: s,
    w: String(width),
    h: String(height),
    fit: 'cover',
    output: 'webp',
    q: '75',
  }).toString()}`
}
